var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { withRouter } from "react-router";
import { VERSION_COOKIE, GRAPH_URL_COOKIE, API_GW_URL_COOKIE } from "./constant/cookieName";
import clearCookie from "./helpers/clearCookie";
import getCookie from "./helpers/getCookie";
import Row from "./Row";
var Version = /** @class */ (function (_super) {
    __extends(Version, _super);
    function Version() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            version: null,
            graphUrl: null,
            apigwUrl: null
        };
        _this.getVersion = function () {
            var version = getCookie(VERSION_COOKIE);
            if (version) {
                _this.setState({ version: version });
            }
        };
        _this.getGraphUrl = function () {
            var graphUrl = getCookie(GRAPH_URL_COOKIE);
            if (graphUrl) {
                _this.setState({ graphUrl: graphUrl });
            }
        };
        _this.getApigwUrl = function () {
            var apigwUrl = getCookie(API_GW_URL_COOKIE);
            if (apigwUrl) {
                _this.setState({ apigwUrl: apigwUrl });
            }
        };
        _this.clearVersion = function () {
            clearCookie(VERSION_COOKIE);
            var _a = window.location, href = _a.href, search = _a.search;
            window.location.href = href.replace(search, "");
        };
        _this.clearGraphUrl = function () {
            clearCookie(GRAPH_URL_COOKIE);
            var _a = window.location, href = _a.href, search = _a.search;
            window.location.href = href.replace(search, "");
        };
        _this.clearApigwUrl = function () {
            clearCookie(API_GW_URL_COOKIE);
            var _a = window.location, href = _a.href, search = _a.search;
            window.location.href = href.replace(search, "");
        };
        return _this;
    }
    Version.prototype.componentDidMount = function () {
        this.getVersion();
        this.getGraphUrl();
        this.getApigwUrl();
    };
    Version.prototype.render = function () {
        var _a = this.state, version = _a.version, graphUrl = _a.graphUrl, apigwUrl = _a.apigwUrl;
        return (React.createElement(React.Fragment, null,
            version && React.createElement(Row, { text: "version", value: version, onClear: this.clearVersion }),
            graphUrl && React.createElement(Row, { text: "graph url", value: graphUrl, onClear: this.clearGraphUrl }),
            apigwUrl && React.createElement(Row, { text: "api gw url", value: apigwUrl, onClear: this.clearApigwUrl })));
    };
    return Version;
}(PureComponent));
export default withRouter(Version);
